import * as ambassadorWixMembersV1CustomFieldSuggestion from './members-v1-custom-field-suggestion-custom-field-suggestions.http.js';
import * as ambassadorWixMembersV1CustomFieldSuggestionTypes from './members-v1-custom-field-suggestion-custom-field-suggestions.types.js';
import * as ambassadorWixMembersV1CustomFieldSuggestionUniversalTypes from './members-v1-custom-field-suggestion-custom-field-suggestions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listCustomFieldSuggestions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1CustomFieldSuggestionUniversalTypes.ListCustomFieldSuggestionsRequest,
  ambassadorWixMembersV1CustomFieldSuggestionTypes.ListCustomFieldSuggestionsRequest,
  ambassadorWixMembersV1CustomFieldSuggestionUniversalTypes.ListCustomFieldSuggestionsResponse,
  ambassadorWixMembersV1CustomFieldSuggestionTypes.ListCustomFieldSuggestionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldSuggestion.listCustomFieldSuggestions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/custom-field-suggestions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCustomFieldSuggestions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldSuggestionUniversalTypes.QueryCustomFieldSuggestionsRequest,
  ambassadorWixMembersV1CustomFieldSuggestionTypes.QueryCustomFieldSuggestionsRequest,
  ambassadorWixMembersV1CustomFieldSuggestionUniversalTypes.QueryCustomFieldSuggestionsResponse,
  ambassadorWixMembersV1CustomFieldSuggestionTypes.QueryCustomFieldSuggestionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomFieldSuggestion.queryCustomFieldSuggestions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-field-suggestions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CustomFieldSuggestion as CustomFieldSuggestionOriginal,
  Privacy as PrivacyOriginal,
  PrivacyWithLiterals as PrivacyWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  SocialTypeType as SocialTypeTypeOriginal,
  SocialTypeTypeWithLiterals as SocialTypeTypeWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  ListCustomFieldSuggestionsRequest as ListCustomFieldSuggestionsRequestOriginal,
  Paging as PagingOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  ListCustomFieldSuggestionsResponse as ListCustomFieldSuggestionsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  QueryCustomFieldSuggestionsRequest as QueryCustomFieldSuggestionsRequestOriginal,
  Query as QueryOriginal,
  QueryCustomFieldSuggestionsResponse as QueryCustomFieldSuggestionsResponseOriginal,
} from './members-v1-custom-field-suggestion-custom-field-suggestions.types.js';
